var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qb-video-list-wrapper" }, [
    Array.isArray(_vm.shortVideo) && _vm.shortVideo.length
      ? _c(
          "ul",
          { staticClass: "qb-video-list" },
          _vm._l(_vm.shortVideo, function (item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "qb-video-item",
                attrs: {
                  id: "qb-video-item-" + index,
                  "data-report": index,
                  "data-exposed": "false",
                  ourl: /^\/play/g.test(item.url)
                    ? "https://wapv.sogou.com" + item.url
                    : item.url,
                },
                on: {
                  click: function ($event) {
                    return _vm.clickOutResult($event, item, index)
                  },
                },
              },
              [
                _c("h3", {
                  staticClass: "qb-video-title",
                  domProps: { innerHTML: _vm._s(item.titleCut) },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "qb-video-content" },
                  [
                    _vm.supportAutoplay && _vm.videoExposedArr.includes(index)
                      ? _c("video", {
                          ref: "video-" + index,
                          refInFor: true,
                          staticClass: "video-player",
                          attrs: {
                            "data-index": index,
                            "data-type": item.videoCdn
                              ? "play"
                              : item.videoMp4
                              ? "scan"
                              : "",
                            src: item.videoCdn || item.videoMp4,
                            width: "100%",
                            height: "100%",
                            playsinline: "",
                            "webkit-playsinline": "",
                            "x5-video-player-type": "h5-page",
                          },
                          domProps: { muted: _vm.mute },
                          on: {
                            progress: _vm.handleVideoFirstPlay,
                            loadeddata: _vm.handleVideoFirstPlay,
                            playing: _vm.handleVideoPlaying,
                            timeupdate: _vm.handleVideoUpdate,
                            pause: _vm.handleVideoPause,
                            ended: _vm.handleVideoEnd,
                            error: _vm.handleVideoError,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    index < 3
                      ? _c("img", {
                          attrs: {
                            id: "video_poster_" + index,
                            src: item.currentTime > 0 ? "" : item.picurl,
                          },
                        })
                      : _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: item.currentTime > 0 ? "" : item.picurl,
                              expression:
                                "item.currentTime > 0 ? '' : item.picurl",
                            },
                          ],
                          attrs: {
                            id: "video_poster_" + index,
                            onerror: "this.style.display='none'",
                          },
                        }),
                    _vm._v(" "),
                    item.playStatus === _vm.PLAY_STATE.ERROR &&
                    _vm.supportAutoplay
                      ? _c("span", { staticClass: "status-to-play" }, [
                          _vm._v("点击播放"),
                        ])
                      : item.playStatus === _vm.PLAY_STATE.LOADING &&
                        index === _vm.activeVideoIndex
                      ? _c("QBVideoLoading", {
                          on: {
                            loadingTimeout: function ($event) {
                              return _vm.handleLoadingTimeout(index)
                            },
                            loadingPolling: function ($event) {
                              return _vm.handleLoadingPolling(item, index)
                            },
                          },
                        })
                      : item.playStatus === _vm.PLAY_STATE.PLAYING &&
                        index === _vm.activeVideoIndex
                      ? _c("span")
                      : _c("span", { staticClass: "status-pause" }),
                    _vm._v(" "),
                    item.showTagName === "合集" && item.showTagDesc
                      ? _c("span", { staticClass: "collection-desc" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.showTagDesc) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeVideoIndex === index && item.videoCdn
                      ? _c("div", { staticClass: "duration" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formatDuration(item)) +
                              "\n        "
                          ),
                        ])
                      : _vm.activeVideoIndex === index &&
                        item.videoMp4 &&
                        item.playedTimes === 0
                      ? _c("div", { staticClass: "duration" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s("片段 " + _vm.formatDuration(item)) +
                              "\n        "
                          ),
                        ])
                      : _vm.activeVideoIndex === index &&
                        item.videoMp4 &&
                        item.playedTimes > 0
                      ? _c(
                          "div",
                          { staticClass: "duration duration-scan-end" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s("看完整视频" + item.duration)
                            ),
                            _c("i", { staticClass: "icon-right-arrow" }),
                          ]
                        )
                      : _c("div", { staticClass: "duration" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.duration) +
                              "\n        "
                          ),
                        ]),
                    _vm._v(" "),
                    _vm.activeVideoIndex === index &&
                    item.videoCdn &&
                    item.currentTime > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "icon-voice",
                            attrs: {
                              href: "javascript:void(0);",
                              uigs:
                                "video_voice_" + (_vm.mute ? "mute" : "play"),
                              uigsparams: _vm.getShortVideoPlayInfo({
                                item: item,
                                index: index,
                              }),
                            },
                            on: { click: _vm.toggleVoice },
                          },
                          [
                            _c("i", {
                              class:
                                "icon-voice-" + (_vm.mute ? "mute" : "open"),
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeVideoIndex === index &&
                    item.videoCdn &&
                    item.currentTime > 0
                      ? _c("span", { staticClass: "video-player-progress" }, [
                          _c("i", {
                            staticClass: "video-player-progress-played",
                            style: "width: " + _vm.formatPercent(item) + "%;",
                          }),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "qb-video-detail",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("SiteIcon", {
                      attrs: {
                        "icon-img": item.siteicon,
                        "icon-type": item.iconType,
                        "is-lazy": index > 2,
                      },
                    }),
                    _vm._v(" "),
                    item.sitename
                      ? _c("span", { staticClass: "video-detail-sitename" }, [
                          _vm._v(_vm._s(item.sitename)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.date
                      ? _c("span", { staticClass: "video-detail-date" }, [
                          _vm._v(_vm._s(item.date)),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { display: "none" },
                  domProps: { innerHTML: _vm._s("<!--v-->") },
                }),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.loadingFinished
      ? _c("div", { staticClass: "loading-result" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }